import React, {useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import CheckButton from 'react-validation/build/button';
import UserService from "../../services/UserService";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {css} from "@emotion/react";
import logo from '../../assets/images/logo.jpg';
import {makeStyles} from '@material-ui/core/styles';
import Spinner from 'reactjs-simple-spinner';


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
    },
}));


const required = (value) => {
    if (!value) {
        return (
            <div className="error">
                This field is required!
            </div>
        );
    }
};


const LogIn = (props) => {
    const form = useRef();
    const checkBtn = useRef();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [usernameError, setUsernameError] = useState('');
    const [passwordError, setPasswordError] = useState('');


    const override = css`
      display: block;
      margin: 0 auto;
    `;

    useEffect(() => {
        setLoading(false);
        setMessage('');
    }, []);

    const removeUsernameErrors = () => {
        setUsernameError('');
    }

    const removePasswordErrors = () => {
        setPasswordError('');
    }

    const onChangeUsername = (e) => {
        setUsername(e.target.value);
    }

    const onChangePassword = (e) => {
        setPassword(e.target.value);
    }

    const handleLogin = (e) => {
        e.preventDefault();


        if (username === null || username === '') {
            toast.warning("Username is required!");
        } else if (password === null || password === '') {

            toast.warning("Please enter your password");
        } else {
            setLoading(true);


            console.log("user1: ", username)
            //call auth service login
            UserService.login(username, password).then((response) => {
                console.log("res: ", response);

                if(response === null || response === undefined){
                    toast.error('Connection error: Reload page and try again. If error persist, please contact system administrator');
                }

                if (response.status == '200') {
                    //store user and token in localStorage
                    localStorage.setItem("user", JSON.stringify(response.data.user));
                    localStorage.setItem("token", JSON.stringify(response.data.token));
                    localStorage.setItem("roles", JSON.stringify(response.data.user.roles))
                    console.log("role based: ", response.data.role_based_permissions);
                    console.log("direct: ", response.data.permissions);
                    localStorage.setItem("role_based_permissions", JSON.stringify(response.data.role_based_permissions))
                    localStorage.setItem("direct_permissions", JSON.stringify(response.data.permissions))
                    localStorage.setItem("isLoggedIn", JSON.stringify(true));
                    props.history.push("/dashboard");
                } else if (response.status == '400') {
                    localStorage.setItem("user", JSON.stringify(response.data.user));
                    props.history.push("/home");
                } else if (response.status == '202') {
                    localStorage.setItem("user", JSON.stringify(response.data.user));
                    props.history.push("/change-password");
                } else if (response.status == '401') {
                    setLoading(false);
                    toast.error('Login Failed: ' + response.data.message);
                } else {
                    setLoading(false);
                    toast.warning('Login Failed: ' + response.data.message);
                }

                console.log("level3: ", response)
            }).catch(error => {
                console.log(error.response);
                setLoading(false);
                toast.warning('Login Failed: ' + error.data.message);
            })
        }


    }

    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={2000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{color: "white"}}
            />

                <div>
                    <div className="container" style={{marginTop: 180}}>
                        <div className="row">
                            <div className="col-lg-8 col-md-6 ml-auto mr-auto">
                                <div className="card card-login">
                                    <Form onSubmit={handleLogin} ref={form} className="form container p-2"
                                          id="login-form">
                                        <center>
                                            <p><a href="#" className="logo2"/></p>
                                            <img src={logo} width={250} alt="logo"/>
                                        </center>


                                        <div className="card-body">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className="fa fa-user"/>
                      </span>
                                                </div>
                                                <input
                                                    type="email"
                                                    disabled={loading}
                                                    className="form-control"
                                                    value={username}
                                                    placeholder="Username"
                                                    onKeyDown={removeUsernameErrors}
                                                    onChange={onChangeUsername}
                                                    required={true}
                                                />
                                                <br/>

                                            </div>
                                            <center><span className="error">{usernameError}</span></center>

                                            <div className="input-group pt-2">
                                                <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className="fa fa-lock"/>
                      </span>
                                                </div>
                                                <input
                                                    type="password"
                                                    disabled={loading}
                                                    className="form-control"
                                                    placeholder="Password"
                                                    value={password}
                                                    onKeyDown={removePasswordErrors}
                                                    onChange={onChangePassword}
                                                    required
                                                /><br/>

                                            </div>
                                            <center><span className="error">{passwordError}</span></center>

                                        </div>


                                        <center>
                                            {loading && (
                                                <Spinner
                                                    size="medium"
                                                    message="..."
                                                    line-fg-color="#64c3c2"
                                                />
                                            )}
                                            {!loading && (
                                                <button
                                                    className="pt-2 btn btn-primary ld-ext-right"
                                                    id="loginUser"
                                                    onClick={handleLogin}
                                                    type="submit"

                                                >
                                                <span style={{fontSize: 18}}>
                                                   SIGN IN&nbsp; <i className="fas fa-arrow-circle-right"></i>
                                                </span>
                                                </button>
                                            )}
                                        </center>
                                        <hr/>

                                        <div
                                            className="footer container text-center font-weight-bold"
                                            style={{paddingLeft: 35}}
                                        >
                                            <span
                                                className="text-secondary text-center"><a>App Version: 1.0.0.4</a></span>
                                        </div>
                                        <CheckButton style={{display: "none"}} ref={checkBtn}/>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        </div>
    )
}

export default LogIn;
